import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Typography, TextField } from "@totalsoft/rocket-ui";
import { TableCellWithWidth } from "components/list/TableComponentsStyled";

export const BalanceSheetDetailsListRowComponent = ({ item, index, handleChange, handleSave }) => {
  const [t] = useTranslation();

  const handleCreditAmountChange = useCallback(
    event => handleChange("creditCurrencyAmount", event, index),
    [handleChange, index]
  );

  const handleDebitAmountChange = useCallback(
    event => handleChange("debitCurrencyAmount", event, index),
    [handleChange, index]
  );

  const handleSaveDetail = useCallback(
    () => handleSave(item),
    [handleSave, item]
  );

  return (
    <TableRow>
      <TableCellWithWidth w={30}>
        <Typography variant="body1">{item.accountName}</Typography>
      </TableCellWithWidth>
      <TableCellWithWidth w={15}>
        <Typography variant="body1">{item.accountSymbol}</Typography>
      </TableCellWithWidth>
      <TableCellWithWidth w={15}>
        <Typography variant="body1">{item.accountTypeName}</Typography>
      </TableCellWithWidth>
      <TableCellWithWidth w={20}>
        <TextField
          isNumeric
          decimalScale={4}
          value={item.debitCurrencyAmount}
          onChange={handleDebitAmountChange}
          label={t("BalanceSheet.Details.DebitAmount")}
          disabled={item.readOnlyYN || item.accountTypeId === -2}
          onBlur={handleSaveDetail}
        />
      </TableCellWithWidth>
      <TableCellWithWidth w={20}>
        <TextField
          isNumeric
          decimalScale={4}
          value={item.creditCurrencyAmount}
          onChange={handleCreditAmountChange}
          label={t("BalanceSheet.Details.CreditAmount")}
          disabled={item.readOnlyYN || item.accountTypeId === -1}
          onBlur={handleSaveDetail}
        />
      </TableCellWithWidth>
    </TableRow>
  );
};

BalanceSheetDetailsListRowComponent.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired
};

export default React.memo(BalanceSheetDetailsListRowComponent);
